export const pageScrollContainerSelector = '.mbs-container-inner';
